module.exports = __webpack_public_path__ + "img/zs2.e195403c.png";